import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getInterviewTechnology } from '../../redux/actions/hr';
import RecruitmentReport from './RecruitmentReport';
import CallReport from './CallReport';
import CompanyReport from './CompanyReport';

const REPORT_TABS = [
  { id: 'recruitment', label: 'Recruitment Report', icon: 'pi pi-chart-bar' },
  { id: 'call', label: 'Call Report', icon: 'pi pi-phone' },
  { id: 'company', label: 'Company Report', icon: 'pi pi-building' }
];

const AdminReports = () => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState('recruitment');

  useEffect(() => {
    dispatch(getInterviewTechnology());
  }, [dispatch]);

  return (
    <div className="rpt-page">
      {/* ── Top Report Tabs Navigation ── */}
      <div className="rpt-top-nav-container">
        <div className="rpt-top-nav">
          {REPORT_TABS.map((tab) => (
            <button
              key={tab.id}
              type="button"
              className={`rpt-top-nav-btn ${activeTab === tab.id ? 'rpt-top-nav-btn--active' : ''}`}
              onClick={() => setActiveTab(tab.id)}>
              <i className={tab.icon} />
              <span>{tab.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* ── Report Tab Content ── */}
      <div className="rpt-tab-content">
        {activeTab === 'recruitment' && <RecruitmentReport />}
        {activeTab === 'call' && <CallReport />}
        {activeTab === 'company' && <CompanyReport />}
      </div>
    </div>
  );
};

export default AdminReports;
